<template>
  <div  v-loading="pageLoading" :style="'width:'+myProductDivWidth+'px;'">
    <ContactAndProduct ref="ContactAndProduct" @chooseProductChanged="chooseProductChanged"></ContactAndProduct>

    <el-divider content-position="left">安装信息</el-divider>
    <el-form class="rule-form" :model="installIncident" :rules="rules" ref="ruleForm" label-width="100px" label-position="left" :hide-required-asterisk="true">
      <el-form-item label="产品颜色" v-if="colorShow" prop="productColor">
        <el-radio-group v-model="installIncident.productColor">
          <el-radio v-for="item in colorList" :key="item.id" :label="item.value">
              {{item.value}}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="购买渠道" prop="channel">
        <el-select v-model="installIncident.channel" placeholder="请选择" style="width: 100%">
          <el-option
              v-for="channel in channels"
              :key="channel"
              :label="channel"
              :value="channel">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="购买日期" prop="buyDate">
        <el-date-picker
            v-model="installIncident.buyDate"
            align="right"
            :editable="false"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 100%;"
            :picker-options="buyDatePicker">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="数量" label-width="125px" prop="productCount" v-if="'智能开关' != product.series">
        <el-input-number v-model="installIncident.productCount" :min="0" :max="10" label="数量" />
      </el-form-item>
      <el-form-item label="期望上门日期" prop="expectDate">
        <el-date-picker
            v-model="installIncident.expectDate"
            align="right"
            :editable="false"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 100%;"
            :picker-options="expectDatePicker">
        </el-date-picker>
      </el-form-item>

      <div v-if="'智能锁' == product.series">
<!--        <div>-->
<!--          <img alt="1" src="../assets/1.jpg" class="demo-image">-->
<!--          <img alt="2" src="../assets/2.jpg" class="demo-image">-->
<!--        </div>-->
        <div class="imgBox">
          <img src="@/assets/znjj.png" preview="0" preview-text="导向片图示" class="demo-image"/>
        </div>
        <el-form-item label="导向片宽度" prop="countervane_width">
          <el-select v-model="installIncident.countervane_width" placeholder="请选择" style="width: 100%">
            <el-option value="24MM">24MM</el-option>
            <el-option value="28MM">28MM</el-option>
            <el-option value="30MM">30MM</el-option>
            <el-option value="33MM">33MM</el-option>
            <el-option value="40MM">40MM</el-option>
            <el-option value="其他">其他</el-option>
          </el-select>
          <el-input
              v-if="'其他' == installIncident.countervane_width"
              v-model="installIncident.countervane_width_other"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              placeholder="请输入宽度（单位MM）" style="width: 100%"></el-input>
        </el-form-item>
<!--        <el-form-item v-if="'其他' == installIncident.countervane_width">-->
<!--          <el-input v-model="installIncident.countervane_width_other" placeholder="请输入宽度（单位MM）" style="width: 100%"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="导向片高度" prop="countervane_height">
          <el-select v-model="installIncident.countervane_height" placeholder="请选择" style="width: 100%">
            <el-option value="200MM">200MM</el-option>
            <el-option value="210MM">210MM</el-option>
            <el-option value="240MM">240MM</el-option>
            <el-option value="260MM">260MM</el-option>
            <el-option value="280MM">280MM</el-option>
            <el-option value="300MM">300MM</el-option>
            <el-option value="320MM">320MM</el-option>
            <el-option value="388MM">388MM</el-option>
            <el-option value="400MM">400MM</el-option>
            <el-option value="其他">其他</el-option>
          </el-select>
          <el-input
              v-if="'其他' == installIncident.countervane_height"
              v-model="installIncident.countervane_height_other"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              placeholder="请输入高度（单位MM）" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item label="导向片类型" prop="countervane_type">
          <el-select v-model="installIncident.countervane_type" placeholder="请选择" style="width: 100%">
            <el-option value="直角单孔">直角单孔</el-option>
            <el-option value="直角双孔">直角双孔</el-option>
            <el-option value="圆角单孔">圆角单孔</el-option>
            <el-option value="圆角双孔">圆角双孔</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门的厚度" prop="door_thick" :show-message="false">
          <el-select v-model="installIncident.door_thick" placeholder="请选择" style="width: 100%">
            <el-option value="40MM">40MM</el-option>
            <el-option value="50MM">50MM</el-option>
            <el-option value="60MM">60MM</el-option>
            <el-option value="70MM">70MM</el-option>
            <el-option value="80MM">80MM</el-option>
            <el-option value="90MM">90MM</el-option>
            <el-option value="100MM">100MM</el-option>
            <el-option value="110MM">110MM</el-option>
          </el-select>
          <span class="door-tip">（其他厚度无法安装）</span>
        </el-form-item>
        <div class="upload-tip">请提供测量单及原门锁（或门）照片（三张 可选）</div>
      </div>
      <div v-if="('晾衣机' == product.series)||('窗帘' == product.series)">
        <el-form-item label="预留电源" prop="reservePower">
          <el-radio-group v-model="installIncident.reservePower">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="否有吊顶" prop="haveCeiling">
          <el-radio-group v-model="installIncident.haveCeiling">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="upload-tip">请提供安装环境照片（不超过3张）</div>
      </div>
      <!-- <div v-if="'窗帘' == product.series">
        <el-form-item label="预留电源" prop="reservePower">
          <el-radio-group v-model="installIncident.reservePower">
            <el-radio :label="是">是</el-radio>
            <el-radio :label="否">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="否有吊顶" prop="haveCeiling">
          <el-radio-group v-model="installIncident.haveCeiling">
            <el-radio :label="是">是</el-radio>
            <el-radio :label="否">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="upload-tip">请提供安装环境照片（不超过3张）</div>
      </div> -->
      <div v-if="'智能开关' == product.series">
        <el-form-item label="开关数量" prop="productCount">
          <el-input v-model="installIncident.productCount" placeholder="选填"></el-input>
        </el-form-item>
        <div class="upload-tip">请提供安装环境照片（不超过3张）</div>
      </div>
      <div v-if="'LED' == product.type">
        <el-form-item label="吊顶材质" prop="ceil_material">
          <el-select v-model="installIncident.ceil_material" placeholder="请选择" style="width: 100%">
            <el-option value="木质吊顶">木质吊顶</el-option>
            <el-option value="石膏吊顶">石膏吊顶</el-option>
            <el-option value="PVC吊顶">PVC吊顶</el-option>
            <el-option value="轻钢龙骨吊顶">轻钢龙骨吊顶</el-option>
            <el-option value="无吊顶">无吊顶</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="楼层高度(米)" prop="storey_height">
          <el-input v-model="installIncident.storey_height" placeholder="请输入" style="width: 100%"></el-input>
        </el-form-item>
        <div class="upload-tip">请提供安装环境照片（不超过3张）</div>
      </div>
      <div v-if="'生活电器' == product.type">
        <el-form-item label="吊顶材质" prop="ceil_material">
          <el-select v-model="installIncident.ceil_material" placeholder="请选择" style="width: 100%">
            <el-option value="木质吊顶">木质吊顶</el-option>
            <el-option value="石膏吊顶">石膏吊顶</el-option>
            <el-option value="PVC吊顶">PVC吊顶</el-option>
            <el-option value="轻钢龙骨吊顶">轻钢龙骨吊顶</el-option>
          </el-select>
        </el-form-item>
        <div class="upload-tip">请提供照片（产品外箱、安装环境）</div>
      </div>
      <div v-if="JSON.stringify(product)!='{}'">
        <el-upload
            :action="this.$uploadURL"
            ref="upload"
            :with-credentials="false"
            :multiple="true"
            list-type="picture-card"
            :on-error="uploadError"
            :on-success="handleAvatarSuccess"
        >
          <i slot="default" class="el-icon-plus"></i>
<!--          <div slot="file" slot-scope="{file}" @click="clickIn" v-clickout="clickOut">-->
          <div slot="file" slot-scope="{file}" @click="clickIn">
            <div >
              <el-progress v-show="file.percentage!=100" type="circle" :percentage="showfilepercentage(file.percentage)"></el-progress>
              <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url" alt="">
              <span class="el-upload-list__item-actions">
                <span
                  v-if="!disabled"
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>

          </div>
        </el-upload>
      </div>
    </el-form>
    <el-divider class="info-divider"></el-divider>
<!--    <button @click="clickIn" v-clickout="clickOut">32121a5d6w</button>-->
    <el-button class="submit-btn" type="primary" @click="submit('ruleForm')">预约安装</el-button>

  </div>
</template>

<script>
    import ContactAndProduct from "./ContactAndProduct"

    export default {
        name: "InstallInfo",
        components:{
          ContactAndProduct
        },
        data(){
            return{
                contact: {},
                product: {},
                pageLoading: false,
                myProductDivWidth: document.documentElement.clientWidth - 48,
                buyDatePicker: {
                    disabledDate: (time) => {
                        // 设置可选择的日期为今天之前
                        const curDate = (new Date()).getTime()
                        const day = 1 * 24 * 3600 * 1000
                        const dateRegion = curDate + day
                        return time.getTime() > dateRegion - 8.64e7
                    }
                },
                expectDatePicker: {
                    disabledDate: (time) => {
                        // 设置可选择的日期为今天之后的一个月内
                        const curDate = (new Date()).getTime()
                        const day = 30 * 24 * 3600 * 1000
                        const dateRegion = curDate + day
                        return time.getTime() < Date.now() ||
                            time.getTime() > dateRegion
                    }
                },
                channels: ['天猫','京东','其他网上商城','线下门店','小区推广','熟人介绍','朋友圈销售','试用体验','内部购买'],
                // 表单
                rules: {
                    channel: [
                        { required: true, message: '请选择购买渠道', trigger: 'change' }
                    ],
                    buyDate: [
                        { type: 'string', required: true, message: '请选择购买日期', trigger: 'change' }
                    ],
                    expectDate: [
                        { type: 'string', required: true, message: '请选择期望上门日期', trigger: 'change' }
                    ],
                    countervane_width: [
                        { required: true, message: '请选择导向片宽度', trigger: 'change' }
                    ],
                    countervane_height: [
                        { required: true, message: '请选择导向片高度', trigger: 'change' }
                    ],
                    door_thick: [
                        { required: true, trigger: 'change' }
                    ],
                    countervane_type: [
                        { required: true, message: '请选择导向片类型', trigger: 'change' }
                    ],
                    ceil_material: [
                        { required: true, message: '请选择吊顶材质', trigger: 'change' }
                    ],
                    storey_height: [
                        { required: true, message: '请输入楼层高度', trigger: 'change' }
                    ],
                    productColor: [
                        { required: true, message: '请选择产品颜色', trigger: 'change' }
                    ],
                    reservePower: [
                        { required: true, message: '请选择是否预留电源', trigger: 'change' }
                    ],
                    haveCeiling: [
                        { required: true, message: '请选择是否有吊顶', trigger: 'change' }
                    ]
                },
                fileUrlList: [],
                disabled: true,
                // 安装工单的规格参数
                spec: {

                },
                // 安装工单
                installIncident: {
                    contactId: '',
                    productType: '',
                    productSeries: '',
                    productModel: '',
                    existAssetsId: 0,    // 联系人已有资产id
                    existProductId: 0,   // 联系人已有产品id
                    buyDate: '',
                    expectDate: '',
                    channel: '',
                    productColor: '',
                    // 智能锁额外规格参数
                    countervane_width:'',   // 导向片宽度
                    countervane_width_other:'',   // 导向片宽度
                    countervane_height:'',  // 导向片高度
                    countervane_height_other:'',  // 导向片高度
                    door_thick:'',          // 门的厚度
                    countervane_type:'',    // 导向片类型
                    // 智能开关额外参数
                    productCount:'',
                    //窗帘、晾衣机
                    reservePower: '',
                    haveCeiling: '',
                    // LED额外规格参数
                    ceil_material:'',       // 吊顶材质
                    storey_height:'',       // 楼层高度
                    specStr: '',
                    fileUrlList: [],
                    openid: '',
                    unionid: '',
                    appid: ''
                },
                colorShow: false,
                colorList: [
                  {id:1,value:'陨石黑'},{id:2,value:'香槟金'}
                ]
            }
        },

        methods:{
            setMyProducts(myProducts){
                this.$refs.ContactAndProduct.setMyProducts(myProducts);
            },
            // 子页面Product改变，调用此函数，给this.product赋值
            chooseProductChanged(){
              this.product = this.$refs.ContactAndProduct.product;
              console.log("InstallInfo.product: ",this.product);
              this.installIncident.existAssetsId = this.$refs.ContactAndProduct.existAssetsId;
              this.installIncident.existProductId = this.$refs.ContactAndProduct.existProductId;
              //更新颜色列表
              this.colorShow = true
              if(this.product.model == 'X1'){
                this.colorList =   [{id:1,value:'红古铜'}]
                this.installIncident.productColor = '红古铜'
              }else if(this.product.model == 'X3'){
                this.colorList =   [{id:1,value:'黑色'}]
                this.installIncident.productColor = '黑色'
              }else if(this.product.model == 'X50'){
                this.colorList =   [{id:1,value:'红古铜'},{id:1,value:'太空灰'}]
              }else if(this.product.model == 'K73'){
                this.colorList =   [{id:1,value:'陨石黑'},{id:1,value:'太空灰'}]
              }else if(this.product.model == 'K75'){
                this.colorList =   [{id:1,value:'摩卡棕'},{id:1,value:'太空灰'}]
              }else if(this.product.model == 'GN-1101'){
                this.colorList =   [{id:1,value:'香槟金'},{id:1,value:'星空灰'},{id:1,value:'皓月白'}]
              }else{
                this.installIncident.productColor = '无'
                this.colorShow = false
              }
            },
            // 图片上传成功
            handleAvatarSuccess(response){
                this.fileUrlList.push(response);
            },
            // 图片删除
            handleRemove(file) {
                // this.$refs.upload.clearFiles();  // 删除全部
                console.log(file.response)
                console.log(this.fileUrlList);
                this.fileUrlList.splice(this.fileUrlList.indexOf(file.response),1);
                console.log(this.fileUrlList);
                this.$refs.upload.handleRemove(file);
            },
            uploadError(error) {
                console.log("error",error);
            },
            showfilepercentage(per){
                // console.log(Math.floor(per) + "%")
                return Math.floor(per);
            },
            clickIn() {
                this.disabled = false;
                // console.log("clicked in");
            },
            clickOut() {
                this.disabled = true;
                // console.log("clicked out");
            },
            // 提交
            submit(formName){
                // console.log(this.contact);
                // console.log(this.product);
                if(this.installIncident.productCount==''){
                  this.$message({
                      type: 'warning',
                      message: '请正确填写数量!',
                      offset: 60
                  });
                  return
                }
                if(JSON.stringify(this.contact)=='{}'){
                    this.contact = this.$refs.ContactAndProduct.$refs.Contact.contact;
                }
                if(this.installIncident.existAssetsId !== 0){
                    this.$message({
                        type: 'warning',
                        message: '请新增需要安装的产品!',
                        offset: 60
                    });
                    return
                }
                if(JSON.stringify(this.product)=='{}'||JSON.stringify(this.contact)=='{}'){
                    this.$message({
                        type: 'warning',
                        message: '请选择联系人产品!',
                        offset: 60
                    });
                    return
                }
                if(this.installIncident.reservePower == '否'){
                  this.$message({
                      type: 'warning',
                      message: '请预留电源后再报单！',
                      offset: 60
                  });
                  return
                }
                if(this.fileUrlList.length == 0){
                  this.$message({
                      type: 'warning',
                      message: '请提供安装环境照片（不超过3张）',
                      offset: 60
                  });
                  return
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                      this.pageLoading = true;
                      this.installIncident.contactId = this.contact.id;
                      this.installIncident.productType = '智能家居';
                      if(this.product.series==null || this.product.series==''){
                        this.$message({
                            type: 'warning',
                            message: '请正确选择您需要安装的产品',
                            offset: 60
                        });
                        return
                      }
                      this.installIncident.productSeries = this.product.series;
                      this.installIncident.productModel = this.product.model;
                      this.spec = {};
                      switch (this.installIncident.productType) {
                          case "智能家居":
                              if(this.installIncident.countervane_width_other){
                                  this.spec.countervaneWidth = this.installIncident.countervane_width_other + "MM";
                              }else{
                                  this.spec.countervaneWidth = this.installIncident.countervane_width;
                              }
                              if(this.installIncident.countervane_height_other){
                                  this.spec.countervaneHeight = this.installIncident.countervane_height_other + "MM";
                              }else{
                                  this.spec.countervaneHeight = this.installIncident.countervane_height;
                              }
                              this.spec.doorThick = this.installIncident.door_thick;
                              this.spec.countervaneType = this.installIncident.countervane_type;
                              break;
                          case "LED":
                              this.spec.ceilMaterial = this.installIncident.ceil_material;
                              this.spec.storeyHeight = this.installIncident.storey_height;
                              break;
                          case "生活电器":
                              this.spec.ceilMaterial = this.installIncident.ceil_material;
                              break;
                      }
                      this.installIncident.specStr = JSON.stringify(this.spec);
                      this.installIncident.fileUrlList = this.fileUrlList;
                      this.installIncident.openid = window.localStorage.getItem("fastopenid");
                      this.installIncident.appid = window.localStorage.getItem("fastappid");
                      this.installIncident.unionid = window.localStorage.getItem("fastunionid");
                      console.log("installIncident:",this.installIncident);
                      this.$axios.post(this.$baseURL + `/incident/install`,this.$qs.stringify(this.installIncident))
                      .then(()=> {
                          console.log("报单成功！");
                          this.$confirm('您已提交成功，我们会尽快处理！', '', {
                              confirmButtonText: '确定',
                              showCancelButton: false,
                              type: 'success',
                              showClose: false,
                              closeOnClickModal: false,
                              customClass: 'message-logout'
                          }).then(() => {
                              // 提交成功点击确定，刷新页面
                              console.log("refresh");
                              this.$router.push({
                                  name:"Auth",
                              })
                          }).catch(() => {
                              // DO NOTHING
                          });
                          this.pageLoading = false;
                      })
                      .catch(error=> {
                          console.log(error);
                          this.$message({
                              type: 'warning',
                              message: '提交失败，请重试或联系客服',
                              offset: 60
                          });
                          this.pageLoading = false;
                      });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        },
        activated() {
            // 联系地址后，返回页面时触发
            this.contact = this.$refs.ContactAndProduct.contact;
        }
    }
</script>

<style scoped>
  .rule-form {
    padding: 0px 10px;
    font-size: 14px;
  }
  .door-tip {
    font-size: 12px;
    color: #606266;
  }
  .demo-image{
    /*width: 152px;*/
    width: 304px;
    height: 152px
  }
</style>
<style>
  .el-upload{
    width: 130px!important;
    height: 130px!important;
  }
  .el-upload-list__item-actions {
    width: 130px!important;
    height: 130px!important;
  }
  .el-upload-list__item-thumbnail {
    width: 130px!important;
    height: 130px!important;
  }
  .el-upload-list__item {
    width: 130px!important;
    height: 130px!important;
  }
</style>
